import {ICategoryItem} from "../interfaces/ICategoryItem";
import {EGeoType} from "../services/IconService";

export const cats: ICategoryItem [] = [

    {
        label: 'Stier og ruter',
        label_de: 'Pfade und Routen',
        label_gb: 'Trails and routes',
        color: '#aaaaaa',
        geotype: EGeoType.Line,
        themes: [5, 666, 3, 4, 8, 9]
    },
    {
        label: 'Vandaktiviteter',
        label_de: 'Aktivitäten am Wasser',
        label_gb: 'Water activities',
        color: '#aaaaaa',
        geotype: EGeoType.Point,
        themes: [
            {
                number: 20000,
                label: 'Strand',
                label_de: 'Strand',
                label_gb: 'Beaches',
                themes: [1061, 1051],
                pictogram: undefined
            },
            6052, 6062, 4191, 4411, 2171]
    },
    {
        label: 'Overnatning',
        label_de: 'Übernachtungsmöglichkeiten',
        label_gb: 'Overnight accommodation',
        color: '#aaaaaa',
        geotype: EGeoType.Point,
        themes: [3012, 3031, 3071]
    },
    {
        label: 'Friluftsaktiviteter',
        label_de: 'Outdooraktivitäten',
        label_gb: 'Outdoor activties',
        color: '#b20d0d',
        geotype: EGeoType.Point,
        themes: [
            4322,
            {
                number: 10000,
                label: 'Legepladser',
                label_de: 'Spielplätze',
                label_gb: 'Playgrounds',
                themes: [1031, 1041],
                pictogram: undefined
            }, 4111, 4142, 4222, 9999, 4101, 1191, 2132]
    },
    {
        label: 'Faciliteter',
        label_de: 'Einrichtungen',
        label_gb: 'Facilities',
        color: '#b20d0d',
        geotype: EGeoType.Point,
        themes: [1022, 3091, 1201, 1122, 888, 1012, 1222,
            {
                number: 10001,
                label: 'Parkering',
                label_de: 'Parken',
                label_gb: 'Parking',
                themes: [1351, 1291],
                pictogram: undefined
            }]
    },
    {
        label: '(Frilufts)seværdigheder',
        label_de: '(Outdoor)sehenswürdigkeiten',
        label_gb: '(Outdoor)sights',
        color: '#aaaaaa',
        geotype: EGeoType.Point,
        themes: [5102, 2022, 2012, {
            label: 'Natur- og kulturformidling',
            label_de: 'Natur- und Kulturvermittlung',
            number: 10001,
            themes: [1302, 2092],
            pictogram: undefined
        }, 5072, 1152]
    }
]
